<div class="mx-auto">
  <app-navbar *ngIf="!hideNavbar()"></app-navbar>
  <p-toast position="top-center"></p-toast>
  <app-spinner></app-spinner>
  <main class="max-w-[1200px] mx-auto">
    <router-outlet></router-outlet>
  </main>
  <footer class="mt-16">
    <app-footer></app-footer>
  </footer>
</div>
